export default "__VITE_ASSET__BHbbO89M__"